<template>
  <v-row no-gutters style="justify-content:center">
    <template v-for="skill in skills">
      <v-col cols="12" sm="3" :key="skill" style="margin:10px;">
        <v-card elevation="3">
          <v-card-title class="flexinall">
            <div>{{ skill[0] }}</div>
            <div>{{ skill[1] }}</div>
          </v-card-title>
          <v-progress-linear
            height="10"
            :value="skill[1]"
            rounded
            striped
            color="#"
            class="styledbar"
            :style="{ background: skill[2] }"
          ></v-progress-linear>
          <br />
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      skills: [
      //   ["C", "90%", "#03a9f4"],
      //   ["C++", "90%", "#FF5772"],
      //   ["Python", "80%", "#CDDC39"],
      //   ["Javascript", "80%", "#28a745"],
      //   ["Typescript", "70%", "#9c27b0"],
      //   ["Go", "60%", "#FF9800"],
          ["HTML5", "60%", "#1abc9c"],
          ["CSS", "70%", "#6200EA"],
          ["XML","60%","#FF9800"],
          ["Latex","60%","#FFC107"],
          ["Markdown","80%","#03a9f4"],

        //   ["React", "75%", "#607d8b"],
      //   ["SQL", "70%", "#1abc9c"],
        //   ["Vue", "80%", "#4caf50"],
        //   ["Flask", "85%", "#00bcd4"],
        //   ["NodeJs", "60%", "#186750"],
        //   ["Express", "60%", "#9c27b0"],
        //   ["Jekyll", "70%", "#E57373"],
        //   ["Gatsby", "65%", "#303F9F"],
        //   ["Docker", "50%", "#1abc9c"],
        //   ["Firebase", "50%", "#007bff"],
        //   ["EJS", "80%", "#e91e63"],
        //   ["Postgres", "60%", "#ff9800"],
        //   ["Tkinter", "65%", "#3f51b5"],
        //   ["Wordpress", "50%", "#28a745"],
      ],
    };
  },
};
</script>

<style scoped>
.styledbar {
  background: #ff5722;
  width: 90%;
  margin: auto;
}
.flexinall {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: inherit; */
}
</style>
